import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, model, OnInit } from '@angular/core';
import { ComplaintTaskHistVo, JobCardDetails } from '../../../../core/services/manage-complaints.service';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { LookupItem } from '../../../../core/services/lookup.service';
import { AuthContext } from '../../../../auth/services/auth.context';

interface DialogData {
  jobCardData: JobCardDetails;
  event: JobCardDetails;
  title: string;
  history: ComplaintTaskHistVo;
}

@Component({
  selector: 'app-complaint-history-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
    CommonModule,
    FormsModule,
    MatCardModule,
    MatTableModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './complaint-history-dialog.component.html',
  styleUrl: './complaint-history-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplaintHistoryDialogComponent implements OnInit, AfterViewInit {

  readonly dialogRef = inject(MatDialogRef<ComplaintHistoryDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly jobCardData = model(this.data.jobCardData);
  readonly event = model(this.data.jobCardData); // Only valid at class member level

  complaintHistoryData!: ComplaintTaskHistVo;
  displayedColumns: string[] = ['jobCardNumber', 'department', 'employee', 'status', 'dateIssued'];

  displayedComplaintColumns: string[] = ['employee', 'department', 'status', 'date', 'notes'];

  jobCardStatus: LookupItem[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private authContext: AuthContext
  ) {
  }

  ngOnInit(): void {
    const lookUps = this.authContext.getLookups();
    this.jobCardStatus = lookUps['JOBCARD_STATUS_TYPE'];
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  getJobCardStatusValue(code: string) {
    const lookup = this.jobCardStatus.find(item => item.lookupCode === code);
    return lookup ? lookup.lookupValue : code;
  }

  onBackClick(): void {
    this.dialogRef.close(
      { 
        okay: false, 
        jobCardData: this.data.jobCardData,
      }
    );
  }

  onOkay() {
    this.dialogRef.close(
      { 
        okay: true, 
        jobCardData: this.data.jobCardData, 
      }
    );
  }

}
